$shm_dashboard_app $mol_book2
	- app shell
	plugins /
		<= Theme $mol_theme_auto
	search_mode? \fts
	search_case_sensitive? true
	agent_enabled? false
	agent_tab_enabled false
	monitoring_only false
	agent_opened? false
	wordstat_enabled false
	mentions_enabled true
	mention_stats_enabled false
	agent_min_version \1.0.15
	dashboard_title_current \BA
	wordstat_task_id? \
	placeholders /
	auto /
		^
		<= auth_route_auto null
		- <= log_visit_auto null
		<= navigation_log_auto null
		<= chart_settings_sync null
	pages <= app_pages /
	Menu_page $shm_dashboard_app_menu
		agent_enabled <= agent_tab_enabled
		monitoring_only <= monitoring_only
		dashboard_rows <= menu_dashboard_rows
		app_section <= app_section \
		agent_opened? <=> agent_opened? false
		wordstat_enabled <= wordstat_enabled
		mentions_enabled <= mentions_enabled
		mention_stats_enabled <= mention_stats_enabled
	Dashboard_list $shm_dashboard_app_dashboard_list
		dashboard_id? => dashboard_id?
		dashboard_model => dashboard_model
		dashboard_rows_all => menu_dashboard_rows
	Wordstat_tasks $shm_wordstat_task_list
		task_id? <=> wordstat_task_id? \
		focus_queries? <=> wordstat_queries_focus? null
	Wordstat_catalog $shm_wordstat_task_catalog
		task_id? <=> wordstat_task_id? \
	Agent_panel $mol_view
		sub /
			<= Agent_page $shm_dashboard_opencode_app
				dashboard <= dashboard_model
				dashboard_id <= dashboard_id?
				dashboard_title <= dashboard_title_current
	Dashboard $shm_dashboard_mentions
		app_id <= dashboard_id?
		dashboard_model <= dashboard_model
		agent_enabled <= agent_enabled
	Wordstat_dashboard $shm_wordstat_dashboard
		dashboard_id <= wordstat_task_id? \
		task_title? <=> wordstat_task_title? \
	Mention_stats_tasks $shm_ba_mention_stats_task_list
		task_id? <=> mention_stats_task_id? \
	Mention_stats_task $shm_ba_mention_stats_task
		task_id <= mention_stats_task_id? \
	Agent_app $shm_dashboard_opencode_app
	Settings_page $mol_page
		title \Настройки
		body /
			<= Settings_screen $mol_list
				rows <= settings_rows /
	Search_settings $shm_ba_search_settings
		search_mode? <=> search_mode? \fts
		search_case_sensitive? <=> search_case_sensitive? true
	User_settings $shm_ba_user_settings
	Chart_settings $shm_echarts_settings
		animation_duration_initial? <=> chart_animation_initial? 300
		animation_duration_update? <=> chart_animation_update? 300
		animation_easing? <=> chart_animation_easing? \cubicInOut
		animation_duration_initial_save? <=> chart_animation_initial_save? null
		animation_duration_update_save? <=> chart_animation_update_save? null
	File_store_list $shm_ba_file_store_list
	Documentation $shm_hitalama_textbook
		text <= docs_text \
